(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elegance-before-after"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-ba-slider]').forEach(function(slider) {
      var wrap = slider.querySelector('[data-ba-before-wrap]');
      var handle = slider.querySelector('[data-ba-handle]');
      if (!wrap || !handle) return;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        wrap.style.width = pct + '%';
        handle.style.left = pct + '%';
        slider.setAttribute('aria-valuenow', Math.round(pct));
      }

      function getPctFromEvent(e) {
        var rect = slider.getBoundingClientRect();
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        return ((x - rect.left) / rect.width) * 100;
      }

      var dragging = false;
      function start(e) { dragging = true; e.preventDefault(); }
      function move(e) {
        if (!dragging) return;
        setPos(getPctFromEvent(e));
      }
      function end() { dragging = false; }

      slider.addEventListener('mousedown', start);
      slider.addEventListener('touchstart', start, { passive: false });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: false });
      window.addEventListener('mouseup', end);
      window.addEventListener('touchend', end);

      slider.addEventListener('click', function(e) {
        setPos(getPctFromEvent(e));
      });

      slider.addEventListener('keydown', function(e) {
        var current = parseFloat(slider.getAttribute('aria-valuenow')) || 50;
        if (e.key === 'ArrowLeft')  setPos(current - 5);
        if (e.key === 'ArrowRight') setPos(current + 5);
        if (e.key === 'Home')       setPos(0);
        if (e.key === 'End')        setPos(100);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
